export default "__VITE_ASSET__BZRauxAx__"